export default __webpack_public_path__ + "static/media/shirtSize.1a748a16.jpeg";